import React from 'react';
import { Filter as FilterAdmin, TextInput } from 'react-admin';

const Filter = (props) => (
  <FilterAdmin {...props}>
    <TextInput label="nome" source="Nome" />
  </FilterAdmin>
);

export default Filter;
